module.exports = __webpack_public_path__ + "static/media/galerija_2019 (2).a66019bc.jpg";